<template>
  <div class="edit-scene">
    <el-form :model="sceneData" ref="sceneData" label-width="200px" class="edit-scene-form">
      
      <el-form-item label="Name" prop="name">
        <el-input v-model="sceneData.name"></el-input>
      </el-form-item>
      
      <el-form-item label="Type" prop="type_id" style="text-align: left">
        <el-select v-model="sceneData.type_id">
          <el-option
            v-for="type in types"
            :key="type.id"
            :label="type.name"
            :value="type.id">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Light Percentage" prop="percentage">
        <el-slider v-model="sceneData.percentage" 
          show-input>
        </el-slider>
      </el-form-item>
      
      <el-form-item label="Light Consumption (kW)" prop="consumption">
        <el-slider v-model="sceneData.consumption" 
          :max="200"
          :step="0.1"
          show-input>
        </el-slider>
      </el-form-item>
      
      <el-form-item label="Device" prop="power_relay" style="align: left;" required>
        <el-select v-model="sceneData.power_relay" placeholder="Device">
          <el-option
              v-for="device in devices"
              :key="device.id"
              :label="device.name"
              :value="device.id">
          </el-option>
        </el-select>
      </el-form-item>

      <div v-if="getDeviceType(sceneData.power_relay) !== 4">

        <el-form-item label="Logical" style="align: left;" required>
          <el-select v-model="sceneData.logical_no" placeholder="Logical no" :disabled="sceneData.power_relay <= 0">
            <el-option
              v-for="logical in logicals"
              :key="logical.logical_no"
              :label="logical.logical_no"
              :value="logical.logical_no">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Function" style="align: left;" required>
          <el-select v-model="sceneData.function_id" placeholder="Function">
            <el-option
              v-for="f in functions"
              :key="f.id"
              :label="f.name"
              :value="f.id">
            </el-option>
          </el-select>
        </el-form-item>

      </div>

      <div v-else>

        <el-form-item label="Group" style="align: left;" required>
          <el-select v-model="sceneData.logical_no" placeholder="Group no" :disabled="sceneData.power_relay <= 0">
            <el-option
              v-for="group in groups"
              :key="group.id || group.groupid"
              :label="group.name"
              :value="group.id || group.groupid">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Scene" style="align: left;" required>
          <el-select v-model="sceneData.function_id" placeholder="CB Scene">
            <el-option
              v-for="scene in cbScenes"
              :key="scene.id"
              :label="scene.name"
              :value="scene.id">
            </el-option>
          </el-select>
        </el-form-item>

      </div>

      <el-form-item>
        <el-button type="save" @click="submit('sceneData')">Save</el-button>
        <el-button type="cancel" @click="close">Cancel</el-button>
      </el-form-item>

    </el-form>
  </div>
</template>

<script>
import auth from '../../../auth';
import requests from '../../../requests';

export default {
  name: 'admin-edit-scene',
  props:['sceneData', 'fieldId'],
  data () {
    return {
      pageName: 'Edit Scene',
      userIsSuperAdmin: false,
      types: [],
      devices:[],
      logicals:[],
      functions:[],
      groups: [],
      cbScenes: [],
      defaultGroups: [
        { id: 1, name: '4 (S)' },
        { id: 2, name: '5 (N)' }
      ],
      defaultCbScenes: [
        { id: 1, name: 'North Full' },
        { id: 2, name: 'South Full' },
        { id: 3, name: '50%' },
        { id: 4, name: '75%' },
        { id: 5, name: 'On' },
        { id: 6, name: 'Off' },
      ]
    }
  },
  methods: {
    editScene(){
      var sceneData = this.sceneData;

      sceneData.field_id = parseInt(this.fieldId);
      sceneData.device_type = this.getDeviceType(sceneData.power_relay);

      var context = this;

      requests.updateScene(this, sceneData, sceneData.scene_id, function (result) {
        if(result.action === 'success'){
          context.$message({
            showClose: true,
            type: 'success',
            message: 'Successfully edited scene ' + sceneData.name
          });

          context.close();

        } else {

          context.$message({
            showClose: true,
            type: 'error',
            message: 'Failed to edited scene: ' + result.msg,
          });
        }
      });

    },
    submit(formName) {

      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.editScene();
          this.reset(formName);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    reset(formName) {
      this.$refs[formName].resetFields();
    },
    close() {
      this.reset('sceneData');
      this.$emit('close');
    },
    getRelays(val){
      var context = this;
      requests.getDeviceRelays(this, val, function(result){
        context.logicals = result.data;
      });
    },
    getDeviceType(id) {
      if(!id || !this.devices.length) return 0
      return this.devices.filter(v => v.id === id)[0].type_id
    },
    getControlBoxGroups () {
      const selectedDevice = this.devices.find(device => device.id === this.sceneData.power_relay)

      return new Promise(resolve => {
        requests.getControlBoxGroups(this, `${selectedDevice.ip}:${selectedDevice.port}`, result => {
          console.log('groups', result)
          if (result && result.status === 200) {
            this.groups = result.data.groups
          } else if (result && result.errno) {
            this.$message({
              type: 'error',
              message: `Groups: Error from ${result.address}: ${result.errno}, ${result.code}`,
              duration: 2000
            })
            this.cbScenes = []
          } else {
            this.groups = this.defaultGroups
          }
          resolve()
        })
      })

    },
    getControlBoxScenes (groupId) {
      const selectedDevice = this.devices.find(device => device.id === this.sceneData.power_relay)

      return new Promise(resolve => {
        requests.getControlBoxScenes(this, `${selectedDevice.ip}:${selectedDevice.port}`, groupId, result => {
        console.log('scenes', result)
          if (result && result.status === 200) {
            this.cbScenes = result.data
          } else if (result && result.errno) {
            this.$message({
              type: 'error',
              message: `Scenes: Error from ${result.address}: ${result.errno}, ${result.code}`,
              duration: 2000
            })
            this.cbScenes = []
          } else {
            this.cbScenes = this.defaultCbScenes
          }

          resolve()
        })
      })
    }
  },
  beforeMount() {
    var profile = JSON.parse(auth.getProfile());
    this.userIsSuperAdmin = (profile.role === 3);
    var context = this;
    
    requests.getSceneTypes(this, function(result){
      context.types = result.data;
    });

    requests.getRelayFunctions(this, function(result){
      context.functions = result.data;
    });

    requests.getRelayData(this, this.sceneData.scene_id, function(result){
      var res = result;
      var data = res.data;
      if(data) {
        context.$set(context.sceneData, 'function_id', data.function_id);
        context.$set(context.sceneData, 'logical_no', data.logical_no);
        context.$set(context.sceneData, 'power_relay', data.device_id);
      }

      requests.getDevices(context, function(result){
        context.devices = result.data;

        if(context.sceneData.power_relay){
          if (context.getDeviceType(context.sceneData.power_relay) !== 4) {
            console.log('NOT control box')
            // Not a control box
            context.getRelays(context.sceneData.power_relay);
          } else {
            console.log('control box')
            context.getControlBoxGroups().then(() => {
              context.getControlBoxScenes(context.sceneData.logical_no)
            })
          }
        }
      });
    });
  },
  watch: {
    'sceneData.power_relay':function(val){
      if(!val || val < 1){
        return false;
      }

      var context = this;

      if (this.getDeviceType(val) !== 4) {
        this.getRelays(val);
      } else {
        this.getControlBoxGroups()
      }
    },
    'sceneData.logical_no': function (groupId) {
      // If not a control box, return
      if (this.getDeviceType(this.sceneData.power_relay) !== 4) {
        return
      }

      this.getControlBoxScenes(groupId)
    }
  }
}
</script>

<style>
  .admin-new-scene {
    display: none;
  }
  
  .show {
    display: block !important;
  }

</style>



// WEBPACK FOOTER //
// EditScene.vue?403f84f4